import { CredentialsNT } from './pages/ListCredentialsNT';
import { CredentialsNTForm } from './pages/FormCredentialsNT';

export const CredentialsNTRoutes = [
  {
    path: '/rede-credenciada',
    component: CredentialsNT,
  },
  {
    path: '/rede-credenciada/edit/:id',
    component: CredentialsNTForm,
  },
  {
    path: '/rede-credenciada/novo',
    component: CredentialsNTForm,
  },
  {
    path: '/rede-credenciada/novo/:duplicateId',
    component: CredentialsNTForm,
  },
];
